import { useMutation } from "@apollo/client";

import { TokenizePaymentMethodDocument } from "../../__generated__/graphql";

/** `tokenizePaymentMethod` mutation (spec §7 / §14.4) — card fields → token. */
export function useTokenizePaymentMethod() {
  return useMutation(TokenizePaymentMethodDocument);
}
